import {
  subCategoryCreateSchema,
  subCategorySchema,
} from "@/schema/console/regular-assessments/SubCategory";
import { z } from "zod";

export const mainCategorySchema = z.object({
  id: z.number(),
  content: z.string(),
  sub_categories: z.array(subCategorySchema),
});

export const mainCategoryCreateSchema = mainCategorySchema
  .omit({
    id: true,
  })
  .extend({
    sub_categories: z.array(subCategoryCreateSchema),
  });

export type MainCategory = z.infer<typeof mainCategorySchema>;
export type MainCategoryCreate = z.infer<typeof mainCategoryCreateSchema>;
